import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Calculator } from "lucide-react";
import PageMeta from "./PageMeta";

// Each entry: lbs uses lbs.oz notation (e.g. 9.8 = 9 lbs 8 oz), kg is decimal kg
const BOAT = [
  { species: "Anglerfish",           sLbs:"30.0",  sKg:"13.608", qLbs:"15.0",  qKg:"6.804",  odLbs:"20.0",  odKg:"9.072",  mnLbs:"15.0",  mnKg:"6.804"  },
  { species: "Bass",                 sLbs:"9.8",   sKg:"4.309",  qLbs:"4.12",  qKg:"2.155",  odLbs:"6.8",   odKg:"2.948",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Bream (Black)",        sLbs:"3.4",   sKg:"1.474",  qLbs:"1.12",  qKg:"0.794",  odLbs:"2.10",  odKg:"1.190",  mnLbs:"1.12",  mnKg:"0.794"  },
  { species: "Bream (Couch's)",      sLbs:"4.6",   sKg:"1.985",  qLbs:"2.3",   qKg:"0.992",  odLbs:"3.8",   odKg:"1.588",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Bream (Gilthead)",     sLbs:"5.0",   sKg:"2.268",  qLbs:"2.8",   qKg:"1.134",  odLbs:"2.10",  odKg:"1.190",  mnLbs:"2.0",   mnKg:"0.908"  },
  { species: "Bream (Pandora)",      sLbs:"3.0",   sKg:"1.361",  qLbs:"1.8",   qKg:"0.681",  odLbs:"2.8",   odKg:"1.134",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Bream (Red)",          sLbs:"3.0",   sKg:"1.361",  qLbs:"1.8",   qKg:"0.681",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Brill",                sLbs:"4.12",  sKg:"2.155",  qLbs:"2.6",   qKg:"1.078",  odLbs:"3.4",   odKg:"1.474",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Bull Huss",            sLbs:"14.8",  sKg:"6.577",  qLbs:"9.0",   qKg:"4.082",  odLbs:"12.8",  odKg:"5.670",  mnLbs:"9.0",   mnKg:"4.082"  },
  { species: "Coalfish",             sLbs:"7.8",   sKg:"3.420",  qLbs:"5.0",   qKg:"2.268",  odLbs:"6.8",   odKg:"2.948",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Cod",                  sLbs:"14.0",  sKg:"6.350",  qLbs:"7.0",   qKg:"3.175",  odLbs:"13.0",  odKg:"5.896",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Comber",               sLbs:"1.0",   sKg:"0.454",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Conger",               sLbs:"55.0",  sKg:"24.947", qLbs:"27.8",  qKg:"12.474", odLbs:"40.0",  odKg:"18.143", mnLbs:"20.0",  mnKg:"9.072"  },
  { species: "Dab",                  sLbs:"1.2",   sKg:"0.510",  qLbs:"0.9",   qKg:"0.255",  odLbs:"0.14",  odKg:"0.397",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "Flounder",             sLbs:"3.0",   sKg:"1.361",  qLbs:"1.0",   qKg:"0.681",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Forkbeard (Greater)",  sLbs:"4.0",   sKg:"1.814",  qLbs:"2.0",   qKg:"0.907",  odLbs:"1.10",  odKg:"0.737",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Garfish",              sLbs:"2.10",  sKg:"1.190",  qLbs:"1.5",   qKg:"0.595",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Gurnard (Grey)",       sLbs:"1.4",   sKg:"0.567",  qLbs:"0.10",  qKg:"0.284",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.10",  mnKg:"0.283"  },
  { species: "Gurnard (Red)",        sLbs:"2.0",   sKg:"0.907",  qLbs:"1.0",   qKg:"0.454",  odLbs:"1.8",   odKg:"0.680",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Gurnard (Tub)",        sLbs:"3.8",   sKg:"1.587",  qLbs:"1.12",  qKg:"0.794",  odLbs:"2.10",  odKg:"1.191",  mnLbs:"1.8",   mnKg:"0.680"  },
  { species: "Haddock",              sLbs:"5.0",   sKg:"2.268",  qLbs:"2.8",   qKg:"1.134",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Hake",                 sLbs:"8.0",   sKg:"3.628",  qLbs:"4.0",   qKg:"1.814",  odLbs:"7.0",   odKg:"3.175",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "John Dory",            sLbs:"5.12",  sKg:"2.608",  qLbs:"2.14",  qKg:"1.304",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "L.S.D.",               sLbs:"3.0",   sKg:"1.361",  qLbs:"2.0",   qKg:"0.907",  odLbs:"2.10",  odKg:"1.191",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Ling",                 sLbs:"26.0",  sKg:"11.793", qLbs:"14.0",  qKg:"6.350",  odLbs:"21.0",  odKg:"9.525",  mnLbs:"14.0",  mnKg:"6.350"  },
  { species: "Lumpsucker",           sLbs:"3.8",   sKg:"1.588",  qLbs:"1.12",  qKg:"0.794",  odLbs:"2.8",   odKg:"1.134",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Mackerel",             sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.8",   odKg:"0.680",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Mackerel (Chub)",      sLbs:"1.4",   sKg:"0.567",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.2",   odKg:"0.397",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Megrim",               sLbs:"1.10",  sKg:"0.737",  qLbs:"0.13",  qKg:"0.369",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Mullet (G. Grey)",     sLbs:"1.12",  sKg:"0.794",  qLbs:"0.14",  qKg:"0.397",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Mullet (Striped Red)", sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.4",   odKg:"0.567",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Mullet (Thick Lip)",   sLbs:"4.8",   sKg:"2.041",  qLbs:"2.4",   qKg:"1.021",  odLbs:"3.8",   odKg:"1.588",  mnLbs:"1.8",   mnKg:"0.680"  },
  { species: "Mullet (Thin Lip)",    sLbs:"2.2",   sKg:"0.964",  qLbs:"1.1",   qKg:"0.482",  odLbs:"1.10",  odKg:"0.737",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Plaice",               sLbs:"3.6",   sKg:"1.531",  qLbs:"1.11",  qKg:"0.766",  odLbs:"2.8",   odKg:"1.134",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Pollock",              sLbs:"12.0",  sKg:"5.442",  qLbs:"6.0",   qKg:"2.721",  odLbs:"13.0",  odKg:"5.897",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Pouting",              sLbs:"3.4",   sKg:"1.474",  qLbs:"1.10",  qKg:"0.737",  odLbs:"2.8",   odKg:"1.134",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Ray (Blonde)",         sLbs:"18.0",  sKg:"8.165",  qLbs:"9.0",   qKg:"4.083",  odLbs:"14.0",  odKg:"6.350",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Ray (Cuckoo)",         sLbs:"4.0",   sKg:"1.814",  qLbs:"3.0",   qKg:"1.361",  odLbs:"3.8",   odKg:"1.588",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Ray (Small Eyed)",     sLbs:"10.8",  sKg:"4.763",  qLbs:"5.4",   qKg:"2.382",  odLbs:"8.8",   odKg:"3.856",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Ray (Spotted)",        sLbs:"5.4",   sKg:"2.381",  qLbs:"3.0",   qKg:"1.361",  odLbs:"4.8",   odKg:"2.041",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Ray (Thornback)",      sLbs:"8.0",   sKg:"3.629",  qLbs:"5.0",   qKg:"2.268",  odLbs:"7.0",   odKg:"3.175",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Rockling (3 Beard)",   sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Scad",                 sLbs:"1.4",   sKg:"0.567",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.2",   odKg:"0.510",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Shark (Blue)",         sLbs:"100.0", sKg:"45.360", qLbs:"50.0",  qKg:"22.680", odLbs:"90.0",  odKg:"40.823", mnLbs:"40.0",  mnKg:"18.144" },
  { species: "Shark (Porbeagle)",    sLbs:"250.0", sKg:"113.398",qLbs:"125.0", qKg:"56.699", odLbs:"200.0", odKg:"90.718", mnLbs:"40.0",  mnKg:"18.144" },
  { species: "Smooth Hound",         sLbs:"21.0",  sKg:"9.525",  qLbs:"10.8",  qKg:"4.763",  odLbs:"15.0",  odKg:"6.804",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Smooth Hound (St)",    sLbs:"21.0",  sKg:"9.525",  qLbs:"10.8",  qKg:"4.763",  odLbs:"15.0",  odKg:"6.804",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Sole (Dover)",         sLbs:"2.8",   sKg:"1.134",  qLbs:"1.4",   qKg:"0.567",  odLbs:"1.10",  odKg:"0.737",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Spurdog",              sLbs:"12.0",  sKg:"5.443",  qLbs:"6.0",   qKg:"2.722",  odLbs:"10.0",  odKg:"4.536",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Tope (C&R Only)",      sLbs:"26.0",  sKg:"11.793", qLbs:"20.0",  qKg:"9.072",  odLbs:"27.0",  odKg:"12.247", mnLbs:"20.0",  mnKg:"9.072"  },
  { species: "Triggerfish",          sLbs:"3.8",   sKg:"1.588",  qLbs:"1.12",  qKg:"0.794",  odLbs:"2.8",   odKg:"1.134",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Turbot",               sLbs:"8.0",   sKg:"3.629",  qLbs:"4.0",   qKg:"1.814",  odLbs:"7.0",   odKg:"3.175",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Weaver (Greater)",     sLbs:"1.10",  sKg:"0.737",  qLbs:"0.14",  qKg:"0.397",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"0.14",  mnKg:"0.397"  },
  { species: "Whiting",              sLbs:"3.12",  sKg:"1.701",  qLbs:"1.14",  qKg:"0.851",  odLbs:"2.12",  odKg:"1.247",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Wrasse (Ballan)",      sLbs:"4.12",  sKg:"2.155",  qLbs:"3.0",   qKg:"1.361",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Wrasse (Cuckoo)",      sLbs:"1.10",  sKg:"0.737",  qLbs:"0.13",  qKg:"0.369",  odLbs:"1.4",   odKg:"0.567",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Wreckfish",            sLbs:"7.8",   sKg:"3.402",  qLbs:"3.12",  qKg:"1.701",  odLbs:"6.8",   odKg:"2.948",  mnLbs:"1.0",   mnKg:"0.454"  },
];

const SHORE = [
  { species: "Amberjack (Guinean)",    sLbs:"2.0",   sKg:"0.907",  qLbs:"1.0",   qKg:"0.454",  odLbs:"1.8",   odKg:"0.680",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Anglerfish",             sLbs:"30.0",  sKg:"13.608", qLbs:"15.0",  qKg:"6.804",  odLbs:"15.0",  odKg:"6.804",  mnLbs:"10.0",  mnKg:"4.536"  },
  { species: "Bass",                   sLbs:"8.0",   sKg:"3.628",  qLbs:"4.0",   qKg:"1.814",  odLbs:"5.0",   odKg:"2.267",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Bream (Black)",          sLbs:"2.4",   sKg:"1.021",  qLbs:"1.2",   qKg:"0.511",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Bream (Couch's)",        sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Bream (Gilthead)",       sLbs:"5.0",   sKg:"2.268",  qLbs:"2.8",   qKg:"1.134",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Bream (Pandora)",        sLbs:"1.0",   sKg:"0.454",  qLbs:"0.12",  qKg:"0.340",  odLbs:"0.14",  odKg:"0.397",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Bream (Rays)",           sLbs:"1.0",   sKg:"0.454",  qLbs:"0.12",  qKg:"0.340",  odLbs:"0.12",  odKg:"0.340",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Bream (Red)",            sLbs:"2.4",   sKg:"1.021",  qLbs:"1.2",   qKg:"0.511",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Bream (White)",          sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Brill",                  sLbs:"2.4",   sKg:"1.021",  qLbs:"1.2",   qKg:"0.511",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Bull Huss",              sLbs:"13.0",  sKg:"5.897",  qLbs:"6.8",   qKg:"2.949",  odLbs:"10.0",  odKg:"4.536",  mnLbs:"8.0",   mnKg:"3.629"  },
  { species: "Coalfish",               sLbs:"1.12",  sKg:"0.794",  qLbs:"1.0",   qKg:"0.454",  odLbs:"1.10",  odKg:"0.737",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Cod",                    sLbs:"5.8",   sKg:"2.495",  qLbs:"2.12",  qKg:"1.248",  odLbs:"3.4",   odKg:"1.474",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Conger",                 sLbs:"20.0",  sKg:"9.072",  qLbs:"10.0",  qKg:"4.536",  odLbs:"18.0",  odKg:"8.165",  mnLbs:"10.0",  mnKg:"4.536"  },
  { species: "Dab",                    sLbs:"1.2",   sKg:"0.510",  qLbs:"0.9",   qKg:"0.255",  odLbs:"0.13",  odKg:"0.369",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "Flounder",               sLbs:"3.0",   sKg:"1.361",  qLbs:"1.8",   qKg:"0.681",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Garfish",                sLbs:"1.12",  sKg:"0.794",  qLbs:"0.14",  qKg:"0.397",  odLbs:"1.4",   odKg:"0.567",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Gurnard (Grey)",         sLbs:"1.0",   sKg:"0.454",  qLbs:"0.8",   qKg:"0.227",  odLbs:"0.14",  odKg:"0.397",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "Gurnard (Red)",          sLbs:"1.4",   sKg:"0.567",  qLbs:"0.10",  qKg:"0.284",  odLbs:"0.13",  odKg:"0.369",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "Gurnard (Tub)",          sLbs:"1.8",   sKg:"0.680",  qLbs:"1.0",   qKg:"0.454",  odLbs:"1.6",   odKg:"0.623",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Haddock",                sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Hake",                   sLbs:"2.8",   sKg:"1.134",  qLbs:"1.4",   qKg:"0.567",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Herring",                sLbs:"0.10",  sKg:"0.283",  qLbs:"0.8",   qKg:"0.227",  odLbs:"0.10",  odKg:"0.283",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "John Dory",              sLbs:"2.8",   sKg:"1.134",  qLbs:"1.4",   qKg:"0.567",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Lesser Spotted Dogfish", sLbs:"3.4",   sKg:"1.474",  qLbs:"2.4",   qKg:"1.021",  odLbs:"2.10",  odKg:"1.191",  mnLbs:"2.4",   mnKg:"1.021"  },
  { species: "Ling",                   sLbs:"6.4",   sKg:"2.835",  qLbs:"3.2",   qKg:"1.418",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Lumpsucker",             sLbs:"5.0",   sKg:"2.268",  qLbs:"2.8",   qKg:"1.134",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Mackerel",               sLbs:"1.12",  sKg:"0.794",  qLbs:"0.14",  qKg:"0.397",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"0.10",  mnKg:"0.283"  },
  { species: "Mackerel (Spanish)",     sLbs:"1.0",   sKg:"0.454",  qLbs:"0.12",  qKg:"0.340",  odLbs:"0.14",  odKg:"0.397",  mnLbs:"0.10",  mnKg:"0.340"  },
  { species: "Megrim",                 sLbs:"1.4",   sKg:"0.567",  qLbs:"0.10",  qKg:"0.284",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.10",  mnKg:"0.284"  },
  { species: "Monkfish",               sLbs:"20.0",  sKg:"9.072",  qLbs:"10.0",  qKg:"4.536",  odLbs:"15.0",  odKg:"6.804",  mnLbs:"10.0",  mnKg:"4.536"  },
  { species: "Mullet (G. Grey)",       sLbs:"2.6",   sKg:"1.077",  qLbs:"1.3",   qKg:"0.539",  odLbs:"1.10",  odKg:"0.737",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Mullet (Striped Red)",   sLbs:"1.4",   sKg:"0.567",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Mullet (Thick Lip)",     sLbs:"5.4",   sKg:"2.381",  qLbs:"2.10",  qKg:"1.191",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Mullet (Thin Lip)",      sLbs:"3.12",  sKg:"1.701",  qLbs:"1.14",  qKg:"0.851",  odLbs:"2.4",   odKg:"1.021",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Plaice",                 sLbs:"2.6",   sKg:"1.077",  qLbs:"1.4",   qKg:"0.567",  odLbs:"1.12",  odKg:"0.794",  mnLbs:"1.4",   mnKg:"0.567"  },
  { species: "Pollock",                sLbs:"8.0",   sKg:"3.629",  qLbs:"4.0",   qKg:"1.815",  odLbs:"5.0",   odKg:"2.268",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Pouting",                sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.10",  mnKg:"0.283"  },
  { species: "Ray (Blonde)",           sLbs:"12.0",  sKg:"5.443",  qLbs:"6.0",   qKg:"2.722",  odLbs:"12.0",  odKg:"5.443",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Ray (Cuckoo)",           sLbs:"4.0",   sKg:"1.814",  qLbs:"2.0",   qKg:"0.907",  odLbs:"2.4",   odKg:"1.021",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Ray (Electric)",         sLbs:"30.0",  sKg:"13.608", qLbs:"15.0",  qKg:"6.804",  odLbs:"20.0",  odKg:"9.072",  mnLbs:"10.0",  mnKg:"4.536"  },
  { species: "Ray (Small Eyed)",       sLbs:"10.0",  sKg:"4.536",  qLbs:"5.0",   qKg:"2.268",  odLbs:"8.8",   odKg:"3.856",  mnLbs:"6.0",   mnKg:"2.722"  },
  { species: "Ray (Spotted)",          sLbs:"5.0",   sKg:"2.268",  qLbs:"3.0",   qKg:"1.134",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Ray (Sting)",            sLbs:"20.0",  sKg:"9.072",  qLbs:"10.0",  qKg:"4.536",  odLbs:"12.0",  odKg:"5.443",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Ray (Thornback)",        sLbs:"10.0",  sKg:"4.536",  qLbs:"5.0",   qKg:"2.268",  odLbs:"8.8",   odKg:"3.856",  mnLbs:"6.0",   mnKg:"2.722"  },
  { species: "Rockling (3 Beard)",     sLbs:"2.0",   sKg:"0.908",  qLbs:"1.0",   qKg:"0.454",  odLbs:"1.10",  odKg:"0.737",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Rockling (Shore)",       sLbs:"1.0",   sKg:"0.454",  qLbs:"0.8",   qKg:"0.227",  odLbs:"0.12",  odKg:"0.340",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "Scad",                   sLbs:"1.0",   sKg:"0.454",  qLbs:"0.10",  qKg:"0.283",  odLbs:"0.13",  odKg:"0.369",  mnLbs:"0.10",  mnKg:"0.283"  },
  { species: "Shark (Blue)",           sLbs:"25.0",  sKg:"11.340", qLbs:"18.0",  qKg:"8.165",  odLbs:"20.0",  odKg:"9.072",  mnLbs:"18.0",  mnKg:"8.165"  },
  { species: "Smooth Hound",           sLbs:"10.0",  sKg:"4.536",  qLbs:"5.0",   qKg:"2.268",  odLbs:"7.8",   odKg:"3.402",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Smooth Hound (St)",      sLbs:"11.0",  sKg:"4.990",  qLbs:"5.8",   qKg:"2.495",  odLbs:"9.0",   odKg:"4.086",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Sole (Dover)",           sLbs:"1.12",  sKg:"0.794",  qLbs:"0.14",  qKg:"0.397",  odLbs:"1.4",   odKg:"0.567",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Spurdog",                sLbs:"10.0",  sKg:"4.536",  qLbs:"5.0",   qKg:"2.268",  odLbs:"6.8",   odKg:"2.948",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Tope (C&R Only)",        sLbs:"20.0",  sKg:"9.072",  qLbs:"20.0",  qKg:"9.072",  odLbs:"25.0",  odKg:"11.340", mnLbs:"20.0",  mnKg:"9.072"  },
  { species: "Triggerfish",            sLbs:"3.0",   sKg:"1.361",  qLbs:"1.8",   qKg:"0.681",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.4",   mnKg:"0.567"  },
  { species: "Tuna (Big Eyed)",        sLbs:"60.0",  sKg:"27.216", qLbs:"30.0",  qKg:"13.608", odLbs:"40.0",  odKg:"18.144", mnLbs:"20.0",  mnKg:"9.072"  },
  { species: "Turbot",                 sLbs:"1.12",  sKg:"0.794",  qLbs:"1.2",   qKg:"0.510",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"1.2",   mnKg:"0.510"  },
  { species: "Weaver (Greater)",       sLbs:"1.4",   sKg:"0.567",  qLbs:"0.10",  qKg:"0.284",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "Whiting",                sLbs:"2.4",   sKg:"1.020",  qLbs:"1.2",   qKg:"0.510",  odLbs:"1.8",   odKg:"0.680",  mnLbs:"0.14",  mnKg:"0.397"  },
  { species: "Wrasse (Ballan)",        sLbs:"5.8",   sKg:"2.494",  qLbs:"3.8",   qKg:"1.588",  odLbs:"4.8",   odKg:"2.041",  mnLbs:"3.8",   mnKg:"1.588"  },
  { species: "Wrasse (Cuckoo)",        sLbs:"1.2",   sKg:"0.510",  qLbs:"0.9",   qKg:"0.255",  odLbs:"0.12",  odKg:"0.340",  mnLbs:"0.8",   mnKg:"0.227"  },
];

// Parse CFSA "lbs.oz" string (e.g. "9.8" = 9 lbs 8 oz) → decimal lbs
function parseLbsOz(str) {
  const [lbsPart, ozPart] = String(str).split(".");
  const lb = parseInt(lbsPart) || 0;
  const oz = ozPart ? parseInt(ozPart) : 0;
  return lb + oz / 16;
}

// Format decimal lbs → "X lbs Y oz" (for threshold reference cards)
function formatLbs(decimalLbs) {
  const lb = Math.floor(decimalLbs);
  const oz = Math.round((decimalLbs - lb) * 16);
  return oz === 0 ? `${lb} lbs` : `${lb} lbs ${oz} oz`;
}

// Format decimal lbs → "X lbs Y oz Z drms" (full precision)
function formatLbsOzDrms(decimalLbs) {
  const totalDrms = Math.round(decimalLbs * 256);
  const lbs  = Math.floor(totalDrms / 256);
  const oz   = Math.floor((totalDrms % 256) / 16);
  const drms = totalDrms % 16;
  const parts = [];
  if (lbs  > 0) parts.push(`${lbs} lbs`);
  if (oz   > 0) parts.push(`${oz} oz`);
  if (drms > 0) parts.push(`${drms} drms`);
  return parts.length > 0 ? parts.join(" ") : "0 oz";
}

const TARGETS = [
  { value: "s",  label: "CFSA Specimen",    field: "sLbs",  color: "text-cyan-300"    },
  { value: "q",  label: "CFSA Qualifying",  field: "qLbs",  color: "text-emerald-300" },
  { value: "od", label: "One Day Specimen", field: "odLbs", color: "text-amber-300"   },
];

function CFSACalculator() {
  const [location, setLocation] = useState("shore");
  const [species, setSpecies]   = useState("");
  const [unit, setUnit]         = useState("lbs");
  const [target, setTarget]     = useState("s");
  const [inputLbs, setInputLbs] = useState("");
  const [inputOz, setInputOz]   = useState("0");
  const [inputDrm, setInputDrm] = useState("0");
  const [inputKg, setInputKg]   = useState("");

  const data    = location === "boat" ? BOAT : SHORE;
  const record  = data.find((r) => r.species === species);

  // Reset species when location changes
  const handleLocationChange = (loc) => { setLocation(loc); setSpecies(""); };

  // Entered weight in decimal lbs (16 drams per oz, 16 oz per lb)
  const enteredDecLbs = unit === "kg"
    ? (parseFloat(inputKg) || 0) / 0.453592
    : (parseInt(inputLbs) || 0) + (parseInt(inputOz) || 0) / 16 + (parseInt(inputDrm) || 0) / 256;

  const hasWeight = enteredDecLbs > 0;

  // Result logic
  let result = null;
  if (record && hasWeight) {
    const mn  = parseLbsOz(record.mnLbs);
    const od  = parseLbsOz(record.odLbs);
    const q   = parseLbsOz(record.qLbs);
    const s   = parseLbsOz(record.sLbs);
    const targetDef = TARGETS.find((t) => t.value === target);
    const targetWeight = parseLbsOz(record[targetDef.field]);
    const pct = ((enteredDecLbs / targetWeight) * 100).toFixed(1);
    const targetLabel = targetDef.label;

    if (enteredDecLbs < mn) {
      result = { label: "Below minimum size", pct, color: "red", detail: `Minimum is ${formatLbs(mn)}` };
    } else if (enteredDecLbs >= s) {
      result = { label: "Full CFSA Specimen!", pct, color: "cyan", detail: `${pct}% of ${targetLabel} weight` };
    } else if (enteredDecLbs >= q) {
      result = { label: "CFSA Qualifying Weight", pct, color: "emerald", detail: `${pct}% of ${targetLabel} weight` };
    } else if (enteredDecLbs >= od) {
      result = { label: "One Day Specimen", pct, color: "amber", detail: `${pct}% of ${targetLabel} weight` };
    } else {
      result = { label: "Meets minimum size", pct, color: "slate", detail: `${pct}% of ${targetLabel} weight` };
    }
  }

  const colorMap = {
    cyan:    { badge: "border-cyan-300/40 bg-cyan-400/15 text-cyan-300",    bar: "bg-cyan-400"    },
    emerald: { badge: "border-emerald-300/40 bg-emerald-400/15 text-emerald-300", bar: "bg-emerald-400" },
    amber:   { badge: "border-amber-300/40 bg-amber-400/15 text-amber-300", bar: "bg-amber-400"   },
    slate:   { badge: "border-white/20 bg-white/5 text-slate-300",          bar: "bg-slate-400"   },
    red:     { badge: "border-red-300/40 bg-red-400/15 text-red-300",       bar: "bg-red-400"     },
  };

  return (
    <div className="mb-10 overflow-hidden rounded-2xl border border-violet-400/30 bg-slate-900 ring-1 ring-violet-400/10 shadow-lg shadow-violet-900/20">
      {/* Accent header bar */}
      <div className="flex items-center gap-3 bg-gradient-to-r from-violet-600/30 to-cyan-600/20 border-b border-violet-400/20 px-6 py-4">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-violet-400/20">
          <Calculator className="h-5 w-5 text-violet-300" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-white">Specimen Weight Calculator</h2>
          <p className="text-sm text-slate-300">Select your location, species and target, then enter your fish weight to see what percentage of the CFSA threshold it achieves.</p>
        </div>
      </div>
      <div className="p-6">

      <div className="grid gap-4 sm:grid-cols-3">
        {/* Location */}
        <div>
          <label className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-400">Location</label>
          <select
            value={location}
            onChange={(e) => handleLocationChange(e.target.value)}
            className="w-full rounded-xl border border-white/10 bg-slate-800 px-3 py-2.5 text-sm text-white outline-none focus:border-cyan-300/40"
          >
            <option value="boat">Boat</option>
            <option value="shore">Shore</option>
          </select>
        </div>

        {/* Species */}
        <div className="sm:col-span-2">
          <label className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-400">Species</label>
          <select
            value={species}
            onChange={(e) => setSpecies(e.target.value)}
            className="w-full rounded-xl border border-white/10 bg-slate-800 px-3 py-2.5 text-sm text-white outline-none focus:border-cyan-300/40"
          >
            <option value="">— Select species —</option>
            {data.map((r) => <option key={r.species} value={r.species}>{r.species}</option>)}
          </select>
        </div>

        {/* Target */}
        <div>
          <label className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-400">Target</label>
          <select
            value={target}
            onChange={(e) => setTarget(e.target.value)}
            className="w-full rounded-xl border border-white/10 bg-slate-800 px-3 py-2.5 text-sm text-white outline-none focus:border-cyan-300/40"
          >
            {TARGETS.map((t) => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </select>
        </div>

        {/* Weight unit */}
        <div>
          <label className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-400">Weight Unit</label>
          <select
            value={unit}
            onChange={(e) => setUnit(e.target.value)}
            className="w-full rounded-xl border border-white/10 bg-slate-800 px-3 py-2.5 text-sm text-white outline-none focus:border-cyan-300/40"
          >
            <option value="lbs">Pounds &amp; Ounces</option>
            <option value="kg">Kilograms (kg)</option>
          </select>
        </div>

        {/* Weight input */}
        {unit === "lbs" ? (
          <div className="sm:col-span-2 flex gap-3">
            <div className="flex-1">
              <label className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-400">Pounds</label>
              <input
                type="number" min="0" placeholder="0"
                value={inputLbs}
                onChange={(e) => setInputLbs(e.target.value)}
                className="w-full rounded-xl border border-white/10 bg-slate-800 px-3 py-2.5 text-sm text-white outline-none focus:border-cyan-300/40"
              />
            </div>
            <div className="flex-1">
              <label className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-400">Ounces (0–15)</label>
              <select
                value={inputOz}
                onChange={(e) => setInputOz(e.target.value)}
                className="w-full rounded-xl border border-white/10 bg-slate-800 px-3 py-2.5 text-sm text-white outline-none focus:border-cyan-300/40"
              >
                {Array.from({ length: 16 }, (_, i) => (
                  <option key={i} value={i}>{i} oz</option>
                ))}
              </select>
            </div>
            <div className="flex-1">
              <label className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-400">Drams (0–15)</label>
              <select
                value={inputDrm}
                onChange={(e) => setInputDrm(e.target.value)}
                className="w-full rounded-xl border border-white/10 bg-slate-800 px-3 py-2.5 text-sm text-white outline-none focus:border-cyan-300/40"
              >
                {Array.from({ length: 16 }, (_, i) => (
                  <option key={i} value={i}>{i} drm</option>
                ))}
              </select>
            </div>
          </div>
        ) : (
          <div className="sm:col-span-2">
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-400">Weight (kg)</label>
            <input
              type="number" min="0" step="0.001" placeholder="0.000"
              value={inputKg}
              onChange={(e) => setInputKg(e.target.value)}
              className="w-full rounded-xl border border-white/10 bg-slate-800 px-3 py-2.5 text-sm text-white outline-none focus:border-cyan-300/40"
            />
          </div>
        )}
      </div>

      {/* Result */}
      {result && (
        <div className={`mt-5 rounded-xl border px-5 py-4 ${colorMap[result.color].badge}`}>
          <div className="flex items-center justify-between gap-4 flex-wrap">
            <div>
              <p className="text-base font-bold">{result.label}</p>
              <p className="mt-0.5 text-sm opacity-80">{result.detail}</p>
              <p className="mt-1.5 text-xs opacity-70 tabular-nums">
                {formatLbsOzDrms(enteredDecLbs)} &nbsp;·&nbsp; {(enteredDecLbs * 0.453592).toFixed(3)} kg
              </p>
            </div>
            <p className="text-3xl font-bold tabular-nums">{result.pct}%</p>
          </div>
          {result.color !== "red" && (
            <div className="mt-3 h-2 w-full rounded-full bg-white/10">
              <div
                className={`h-2 rounded-full transition-all duration-500 ${colorMap[result.color].bar}`}
                style={{ width: `${Math.min(parseFloat(result.pct), 100)}%` }}
              />
            </div>
          )}
        </div>
      )}

      {/* Threshold reference */}
      {record && (
        <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-4 text-xs">
          {[
            { label: "Specimen",        field: "s",  color: "text-cyan-300"    },
            { label: "CFSA Qualifying", field: "q",  color: "text-emerald-300" },
            { label: "One Day",         field: "od", color: "text-amber-300"   },
            { label: "Min Size",        field: "mn", color: "text-slate-400"   },
          ].map(({ label, field, color }) => (
            <div key={field} className="rounded-lg border border-white/10 bg-white/5 px-3 py-2">
              <p className={`font-semibold ${color}`}>{label}</p>
              <p className="mt-0.5 text-white font-medium">{formatLbs(parseLbsOz(record[field + "Lbs"]))}</p>
              <p className="text-slate-500">{record[field + "Kg"]} kg</p>
            </div>
          ))}
        </div>
      )}
      </div>
    </div>
  );
}

function val(r, field, metric) {
  return metric ? `${r[field + "Kg"]} kg` : `${r[field + "Lbs"]}`;
}

function SpecimenTable({ data, metric }) {
  const [filterText, setFilterText] = useState("");
  const filtered = filterText.trim()
    ? data.filter((r) => r.species.toLowerCase().includes(filterText.toLowerCase()))
    : data;

  return (
    <>
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search species…"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          className="w-full max-w-sm rounded-xl border border-white/20 bg-slate-900/80 px-4 py-2.5 text-sm text-white outline-none focus:border-cyan-300/40 placeholder:text-slate-500"
        />
      </div>
      <div className="overflow-x-auto rounded-2xl border border-white/10">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="border-b border-white/10 bg-slate-800/80 text-xs font-semibold uppercase tracking-widest">
              <th className="px-3 py-3 text-left text-white/60">Species</th>
              <th className="border-l border-white/10 px-3 py-3 text-center text-cyan-300">Specimen</th>
              <th className="border-l border-white/10 px-3 py-3 text-center text-emerald-300">CFSA Qualifying</th>
              <th className="border-l border-white/10 px-3 py-3 text-center text-amber-300">One Day</th>
              <th className="border-l border-white/10 px-3 py-3 text-center text-slate-400">Min Size</th>
            </tr>
            <tr className="border-b border-white/10 bg-slate-900/60 text-xs text-slate-500">
              <th className="px-3 py-1.5 text-left font-normal"></th>
              {["cyan","emerald","amber","slate"].map((c) => (
                <th key={c} className="border-l border-white/10 px-3 py-1.5 text-center font-normal">
                  {metric ? "kg" : "lbs · oz"}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length ? filtered.map((r, i) => (
              <tr key={r.species} className={`border-b border-white/5 transition hover:bg-white/5 ${i % 2 === 0 ? "bg-slate-950/40" : "bg-slate-900/30"}`}>
                <td className="px-3 py-2.5 font-semibold text-white whitespace-nowrap">{r.species}</td>
                <td className="border-l border-white/10 px-3 py-2.5 text-center font-medium tabular-nums text-cyan-200">{val(r, "s", metric)}</td>
                <td className="border-l border-white/10 px-3 py-2.5 text-center font-medium tabular-nums text-emerald-200">{val(r, "q", metric)}</td>
                <td className="border-l border-white/10 px-3 py-2.5 text-center font-medium tabular-nums text-amber-200">{val(r, "od", metric)}</td>
                <td className="border-l border-white/10 px-3 py-2.5 text-center font-medium tabular-nums text-slate-400">{val(r, "mn", metric)}</td>
              </tr>
            )) : (
              <tr><td colSpan={5} className="px-4 py-6 text-center text-slate-400">No species match your search.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default function CFSASpecimenPage() {
  const navigate = useNavigate();
  const [tab, setTab]       = useState("boat");
  const [metric, setMetric] = useState(false);

  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta
        title="CFSA Specimen Fish Weights | Redruth Sea Angling Association"
        description="CFSA specimen qualifying weights by species for boat and shore sea angling, plus a specimen weight calculator for Cornish anglers."
        keywords="CFSA specimen weights, specimen fish Cornwall, sea angling specimen calculator, Redruth Sea Angling Association"
        url="https://www.redruthseaanglingassociation.co.uk/cfsa-specimen"
      />
      <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">

        <div className="mb-8 flex items-center gap-4">
          <button type="button" onClick={() => navigate(-1)}
            className="standalone-only group inline-flex items-center gap-1.5 rounded-full border border-cyan-400/20 bg-white/5 px-4 py-2 text-sm font-medium text-slate-200 shadow-lg shadow-black/20 backdrop-blur transition hover:-translate-x-0.5 hover:border-cyan-300/40 hover:bg-cyan-400/10 hover:text-white">
            ← Back
          </button>
          <div>
            <h1 className="heading-glow text-2xl font-bold text-white sm:text-3xl">CFSA Specimen Fish Weights</h1>
            <p className="mt-1 text-sm text-slate-400">Cornwall Federation of Sea Anglers · 2023–2025</p>
          </div>
        </div>

        {/* Boat / Shore tabs + unit toggle */}
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
          <div className="flex gap-2">
            {["boat","shore"].map((t) => (
              <button key={t} type="button" onClick={() => setTab(t)}
                className={`rounded-xl px-5 py-2.5 text-sm font-semibold capitalize transition ${tab === t ? "bg-cyan-400 text-slate-950" : "border border-white/10 bg-white/5 text-slate-300 hover:bg-white/10"}`}>
                {t}
              </button>
            ))}
          </div>
          <div className="flex items-center gap-1 rounded-xl border border-white/10 bg-white/5 p-1">
            <button type="button" onClick={() => setMetric(false)}
              className={`rounded-lg px-3 py-1.5 text-xs font-semibold transition ${!metric ? "bg-white/15 text-white" : "text-slate-400 hover:text-white"}`}>
              lbs / oz
            </button>
            <button type="button" onClick={() => setMetric(true)}
              className={`rounded-lg px-3 py-1.5 text-xs font-semibold transition ${metric ? "bg-white/15 text-white" : "text-slate-400 hover:text-white"}`}>
              kg
            </button>
          </div>
        </div>

        <CFSACalculator />

        <SpecimenTable key={tab} data={tab === "boat" ? BOAT : SHORE} metric={metric} />

        <p className="mt-4 text-xs text-slate-500">
          {metric
            ? "Weights shown in kilograms (kg)."
            : "Weights in lbs · oz format (e.g. 9.8 = 9 lbs 8 oz, 4.12 = 4 lbs 12 oz)."
          } Source: CFSA published specimen lists 2023–2025.
        </p>
      </div>
    </div>
  );
}
